import { footerIndexGroups } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-secondary-200 bg-secondary-100/70">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                爆料黑料
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注爆料黑料合集与黑料汇总的资讯聚合主页，按人物、事件分类整理黑料大合集与黑料打包资源，持续更新黑料全集，帮你一次看够不迷路。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-background-50 px-3 py-1 text-[11px] text-foreground-600 ring-1 ring-background-200">
                每日整理更新
              </span>
              <span className="rounded-full bg-background-50 px-3 py-1 text-[11px] text-foreground-600 ring-1 ring-background-200">
                按话题归档
              </span>
              <span className="rounded-full bg-background-50 px-3 py-1 text-[11px] text-foreground-600 ring-1 ring-background-200">
                索引清晰
              </span>
            </div>
          </div>

          {footerIndexGroups.map((group) => (
            <div key={group.title} className="md:col-span-2">
              <h3 className="font-heading text-sm font-bold text-foreground-950">
                {group.title}
              </h3>
              <ul className="mt-3 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#collections"
                      className="cursor-pointer whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <h3 className="font-heading text-sm font-bold text-foreground-950">
              返回
            </h3>
            <ul className="mt-3 flex flex-col gap-2.5">
              <li>
                <a
                  href="#top"
                  className="cursor-pointer whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  回到顶部
                </a>
              </li>
              <li>
                <a
                  href="#topics"
                  className="cursor-pointer whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  话题墙
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 爆料黑料 · 黑料汇总整理示例站，内容均为虚构演示。
          </p>
          <p className="max-w-2xl text-xs leading-relaxed text-foreground-500">
            本站不提供任何真实投稿、下载或个人信息收录入口，所有条目仅用于版式演示。
          </p>
        </div>
      </div>
    </footer>
  );
}